import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Layout from '@/components/layout';
import Loadable from '@/components/Loadable';
const Home = Loadable(lazy(() => import('@/pages/home')));
const Profile = Loadable(lazy(() => import('@/pages/profile')));
const OrgIndex = Loadable(lazy(() => import('@/pages/org')));
const SbtDetailPage = Loadable(lazy(() => import('@/pages/sbt/detail')));
const GitcoinPage = Loadable(lazy(() => import('@/pages/donation/gitcoin')));
const OrgSendPage = Loadable(lazy(() => import('@/pages/org/send')));
const ProfileSetting = Loadable(lazy(() => import('@/pages/profile/setting')));
const ProfileClaim = Loadable(lazy(() => import('@/pages/profile/claim')));
const OrgEdit = Loadable(lazy(() => import('@/pages/org/edit')));
const SbtHistoryPage = Loadable(lazy(() => import('@/pages/sbt/history')));
const SbtEditPage = Loadable(lazy(() => import('@/pages/sbt/edit')));
const NotFound = Loadable(lazy(() => import('@/pages/4xx/404')));

/**
 * 公开路由
 * org/:id
 * user/:address
 * sbt/:contract/:tokenid
 *
 * 私密路由
 * profile/setting
 *
 * manage/org/send
 * manage/org/history
 * manage/org/edit
 */

const MainRoutes = {
  path: '/',
  element: <Layout />,
  children: [
    {
      path: '/',
      element: <Navigate to="/home" />
    },
    {
      path: '/home',
      element: <Home />,
      meta: {
        auth: false
      }
    },
    {
      path: '/user/:id',
      element: <Profile />,
      meta: {
        auth: false
      }
    },
    {
      path: '/org/:id',
      element: <OrgIndex />,
      meta: {
        auth: false
      }
    },
    {
      path: '/sbt/:org/:id',
      element: <SbtDetailPage />,
      meta: {
        auth: false
      }
    },
    {
      path: '/donation/gitcoin',
      element: <GitcoinPage />,
      meta: {
        auth: false
      }
    },
    {
      // 个人信息编辑
      path: '/profile/setting',
      element: <ProfileSetting />,
      meta: {
        auth: true
      }
    },
    {
      // 通知mail
      path: '/profile/claim',
      element: <ProfileClaim />,
      meta: {
        auth: true
      }
    },
    {
      // 组织信息编辑和创建
      path: '/manage/org/edit',
      element: <OrgEdit />,
      meta: {
        auth: true
      }
    },
    {
      // sbt发送
      path: '/manage/org/send',
      element: <OrgSendPage />,
      meta: {
        auth: true
      }
    },
    {
      // 组织历史总表
      path: '/manage/org/history',
      element: <SbtHistoryPage />,
      meta: {
        auth: true
      }
    },
    {
      // 编辑组织内的 sbt 信息
      path: '/manage/org/sbt/edit',
      element: <SbtEditPage />,
      meta: {
        auth: true
      }
    },
    {
      // 404
      path: '/404',
      element: <NotFound />,
      meta: {
        auth: false
      }
    },
    {
      // 404
      path: '/*',
      element: <NotFound />,
      meta: {
        auth: false
      }
    }
  ]
};

export default MainRoutes;
